import BaseSelectBox from 'components/atoms/base-select-box';
import { useTranslation } from 'react-i18next';

import type { CcmStatuses } from 'infrastructure/enums';
import type { FC } from 'react';

interface StatusSelectProps {
  value: CcmStatuses | 'other' | undefined;
  onChange: (value: CcmStatuses | 'other') => void;
}

const StatusSelect: FC<StatusSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <BaseSelectBox
      placeholder={t('labels.status')}
      minWidth="150px"
      value={value}
      options={[
        { label: 'Enrolled', value: 'enrolled' },
        { label: 'Other', value: 'other' },
      ]}
      onChange={onChange}
      allowClear
    />
  );
};
export default StatusSelect;
